module.exports = __webpack_public_path__ + "assets/img/video_text.809b21a5.jpg";